import { render, staticRenderFns } from "./GanttRegendModal.vue?vue&type=template&id=eefd4690&scoped=true"
import script from "./GanttRegendModal.vue?vue&type=script&lang=js"
export * from "./GanttRegendModal.vue?vue&type=script&lang=js"
import style0 from "./GanttRegendModal.vue?vue&type=style&index=0&id=eefd4690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefd4690",
  null
  
)

export default component.exports